"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideTooltipComponents = exports.getTooltipData = exports.moveTooltipLine = exports.moveHoverBackground = exports.movePeakTroughTooltipXAxisMarkers = exports.movePeakTroughHoverMarkers = exports.getRecoveryDataForTroughLocation = exports.formatTooltipXAxisValue = void 0;
var tslib_1 = require("tslib");
var isEqual_1 = tslib_1.__importDefault(require("date-fns/isEqual"));
var d3 = tslib_1.__importStar(require("d3"));
var ChartTooltipUtils_1 = require("../ChartTooltipUtils");
exports.formatTooltipXAxisValue = function (value) {
    return d3.timeFormat('%b %Y')(value);
};
exports.getRecoveryDataForTroughLocation = function (lineData, troughLocation) {
    var recoveryDataForTrough = lineData.recoveryData.find(function (d) {
        return isEqual_1.default(d.trough.x, troughLocation.x);
    });
    return {
        peakLocation: recoveryDataForTrough === null || recoveryDataForTrough === void 0 ? void 0 : recoveryDataForTrough.peak,
        recoveryLocation: recoveryDataForTrough === null || recoveryDataForTrough === void 0 ? void 0 : recoveryDataForTrough.recovery,
    };
};
exports.movePeakTroughHoverMarkers = function (_a) {
    var TroughHoverMarker = _a.TroughHoverMarker, PeakHoverMarker = _a.PeakHoverMarker, RecoveryHoverMarker = _a.RecoveryHoverMarker, troughLocation = _a.troughLocation, peakLocation = _a.peakLocation, recoveryLocation = _a.recoveryLocation, xScale = _a.xScale, yScale = _a.yScale;
    d3.select(TroughHoverMarker)
        .attr('width', 20)
        .attr('x', xScale(troughLocation.x) - 10)
        .attr('y', yScale(troughLocation.y) - 4);
    if (peakLocation) {
        d3.select(PeakHoverMarker)
            .attr('width', 20)
            .attr('x', xScale(peakLocation.x) - 10)
            .attr('y', yScale(peakLocation.y) - 4);
    }
    if (recoveryLocation) {
        d3.select(RecoveryHoverMarker)
            .attr('width', 20)
            .attr('x', xScale(recoveryLocation.x) - 10)
            .attr('y', yScale(recoveryLocation.y) - 4);
    }
};
exports.movePeakTroughTooltipXAxisMarkers = function (_a) {
    var PeakXAxisMarker = _a.PeakXAxisMarker, PeakXAxisMarkerText = _a.PeakXAxisMarkerText, TroughTooltipMarker = _a.TroughTooltipMarker, TroughTooltipMarkerText = _a.TroughTooltipMarkerText, RecoveryXAxisMarker = _a.RecoveryXAxisMarker, RecoveryXAxisMarkerText = _a.RecoveryXAxisMarkerText, peakLocation = _a.peakLocation, xScale = _a.xScale, troughLocation = _a.troughLocation, recoveryLocation = _a.recoveryLocation;
    ChartTooltipUtils_1.moveTooltipXAxisMarker({
        tooltipXAxisMarker: TroughTooltipMarker,
        tooltipXAxisMarkerText: TroughTooltipMarkerText,
        xScale: xScale,
        xVal: troughLocation.x,
        markerText: exports.formatTooltipXAxisValue(troughLocation.x),
    });
    d3.select(TroughTooltipMarker).attr('opacity', 1);
    d3.select(TroughTooltipMarkerText).attr('opacity', 1);
    if (peakLocation) {
        ChartTooltipUtils_1.moveTooltipXAxisMarker({
            tooltipXAxisMarker: PeakXAxisMarker,
            tooltipXAxisMarkerText: PeakXAxisMarkerText,
            xScale: xScale,
            xVal: peakLocation.x,
            markerText: exports.formatTooltipXAxisValue(peakLocation.x),
        });
        d3.select(PeakXAxisMarker).attr('opacity', 1);
        d3.select(PeakXAxisMarkerText).attr('opacity', 1);
    }
    if (recoveryLocation) {
        ChartTooltipUtils_1.moveTooltipXAxisMarker({
            tooltipXAxisMarker: RecoveryXAxisMarker,
            tooltipXAxisMarkerText: RecoveryXAxisMarkerText,
            xScale: xScale,
            xVal: recoveryLocation.x,
            markerText: exports.formatTooltipXAxisValue(recoveryLocation.x),
        });
        d3.select(RecoveryXAxisMarker).attr('opacity', 1);
        d3.select(RecoveryXAxisMarkerText).attr('opacity', 1);
    }
};
exports.moveHoverBackground = function (_a) {
    var HoverBackground = _a.HoverBackground, peakLocation = _a.peakLocation, recoveryLocation = _a.recoveryLocation, xScale = _a.xScale, yScale = _a.yScale, peakValue = _a.peakValue, chartWidth = _a.chartWidth, chartHeight = _a.chartHeight;
    var hoverBackgroundXStart = peakLocation ? xScale(peakLocation.x) : 0;
    var hoverBackgroundXEnd = recoveryLocation
        ? xScale(recoveryLocation.x)
        : chartWidth;
    d3.select(HoverBackground)
        .attr('x', hoverBackgroundXStart)
        .attr('y', yScale(peakValue))
        .attr('height', chartHeight - yScale(peakValue))
        .attr('width', hoverBackgroundXEnd - hoverBackgroundXStart);
};
exports.moveTooltipLine = function (_a) {
    var troughLocation = _a.troughLocation, xScale = _a.xScale, yScale = _a.yScale, peakValue = _a.peakValue, TooltipLine = _a.TooltipLine;
    d3.select(TooltipLine)
        .attr('stroke', '#252627')
        .attr('x1', xScale(troughLocation.x))
        .attr('x2', xScale(troughLocation.x))
        .attr('y1', yScale(peakValue))
        .attr('y2', yScale(troughLocation.y) - 4);
};
exports.getTooltipData = function (_a) {
    var peakLocation = _a.peakLocation, recoveryLocation = _a.recoveryLocation, troughLocation = _a.troughLocation;
    return {
        depth: troughLocation.y,
        peak: peakLocation ? exports.formatTooltipXAxisValue(peakLocation.x) : '--',
        trough: exports.formatTooltipXAxisValue(troughLocation.x),
        recovered: recoveryLocation
            ? exports.formatTooltipXAxisValue(recoveryLocation.x)
            : '--',
    };
};
exports.hideTooltipComponents = function (_a) {
    var TroughHoverMarker = _a.TroughHoverMarker, PeakHoverMarker = _a.PeakHoverMarker, RecoveryHoverMarker = _a.RecoveryHoverMarker, HoverBackground = _a.HoverBackground, TooltipLine = _a.TooltipLine, Tooltip = _a.Tooltip, PeakXAxisMarker = _a.PeakXAxisMarker, PeakXAxisMarkerText = _a.PeakXAxisMarkerText, TroughTooltipMarker = _a.TroughTooltipMarker, TroughTooltipMarkerText = _a.TroughTooltipMarkerText, RecoveryXAxisMarker = _a.RecoveryXAxisMarker, RecoveryXAxisMarkerText = _a.RecoveryXAxisMarkerText;
    d3.select(TroughHoverMarker).attr('width', 0);
    d3.select(PeakHoverMarker).attr('width', 0);
    d3.select(RecoveryHoverMarker).attr('width', 0);
    d3.select(HoverBackground).attr('width', 0);
    d3.select(TooltipLine).attr('stroke', 'none');
    d3.select(Tooltip).style('visibility', 'hidden');
    d3.select(TroughTooltipMarker).attr('opacity', 0);
    d3.select(TroughTooltipMarkerText).attr('opacity', 0);
    d3.select(PeakXAxisMarker).attr('opacity', 0);
    d3.select(PeakXAxisMarkerText).attr('opacity', 0);
    d3.select(RecoveryXAxisMarker).attr('opacity', 0);
    d3.select(RecoveryXAxisMarkerText).attr('opacity', 0);
};
